import { createStore } from 'satcheljs';
import { getGuid } from 'owa-guid';
var initialImmersiveReaderStore = {
    sessionId: getGuid(),
    isLoading: false,
    immersiveReaderFrameState: 0 /* Closed */,
    apiResponse: null,
};
export var getStore = createStore('immersivereader', initialImmersiveReaderStore);
var store = getStore();
export default store;
//# sourceMappingURL=Store.js.map